import { render } from "./ModalCancelVoucher.vue?vue&type=template&id=8ba0164e"
import script from "./ModalCancelVoucher.vue?vue&type=script&lang=js"
export * from "./ModalCancelVoucher.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__